import { OnSelectChange, AntSelectOption } from '../AntSelect';

export const getOptionsWithSelectAll = (
  options: AntSelectOption[],
  allOptionText: string,
  onChange?: OnSelectChange,
) => {
  const allOption = { label: <b>{allOptionText}</b>, value: '_SELECT_ALL_' } as AntSelectOption;
  const optionsWithSelectAll = options.length ? [allOption, ...options] : options;

  const onChangeOrSelectAll: OnSelectChange = (selectedValues, selectedOptions) => {
    if ((selectedValues as any[]).includes(allOption.value)) {
      onChange?.(
        options.map(({ value }) => value),
        options,
      );
    } else {
      onChange?.(selectedValues, selectedOptions);
    }
  };

  return [optionsWithSelectAll, onChangeOrSelectAll] as const;
};
